import { render, staticRenderFns } from "./PersonConjugalDetails.vue?vue&type=template&id=26fce967&"
import script from "./PersonConjugalDetails.vue?vue&type=script&lang=js&"
export * from "./PersonConjugalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports